import { z } from "zod";

export const modulatorPowerMeasureDto = z.object({
  meteringDateTime: z.coerce.date(), // not executed, thanks zodios
  powerValue1: z.number().nullable(),
  powerValue2: z.number().nullable(),
  powerValue3: z.number().nullable(),
  powerValue4: z.number().nullable(),
  powerValue5: z.number().nullable(),
  powerValue6: z.number().nullable(),
});

export type TModulatorPowerMeasureDto = z.infer<typeof modulatorPowerMeasureDto>;

export const modulatorPowerMeasureHistoryDto = z.object({
  historyPoints: z.array(modulatorPowerMeasureDto),
});

export type TModulatorPowerMeasureHistoryDto = z.infer<typeof modulatorPowerMeasureHistoryDto>;
